import { useTranslation } from 'next-i18next';

interface OffersInfo {
  offersText: string;
  isActiveOffersTextColor: boolean;
  isPendingOffersBgColor: boolean;
  shouldCtaLaunchModal: boolean;
  ctaText: string;
  isCtaButton: boolean;
}

interface NegotiationSummary {
  ongoingNegotiationsCount: number;
  totalNegotiationsCount: number;
  pendingSellerActionCount: number;
}

export const useGetOffersInfo = (negotiationSummary: NegotiationSummary): OffersInfo => {
  const { pendingSellerActionCount, ongoingNegotiationsCount, totalNegotiationsCount } = negotiationSummary;
  const { t } = useTranslation('negotiation');
  let offersText = '';
  let isActiveOffersTextColor = false;
  let isPendingOffersBgColor = false;
  let shouldCtaLaunchModal = false;
  let ctaText = t('NEGOTIATION_LISTING.OFFERS_SHARED.CTA.VIEW');
  let isCtaButton = false;

  if (ongoingNegotiationsCount > 1) {
    offersText = t('NEGOTIATION_LISTING.OFFERS_SHARED.ACTIVE_OFFERS', {
      count: ongoingNegotiationsCount,
    });
    isActiveOffersTextColor = true;
    isCtaButton = true;
  } else if (ongoingNegotiationsCount === 1) {
    offersText = t('NEGOTIATION_LISTING.OFFERS_SHARED.ACTIVE_OFFER', {
      count: 1,
    });
    isActiveOffersTextColor = true;
    shouldCtaLaunchModal = true;
    isCtaButton = true;
  } else if (totalNegotiationsCount === 1) {
    offersText = t('NEGOTIATION_LISTING.OFFERS_SHARED.OFFER', {
      count: 1,
    });
    shouldCtaLaunchModal = true;
  } else {
    offersText = t('NEGOTIATION_LISTING.OFFERS_SHARED.OFFERS', {
      count: totalNegotiationsCount,
    });
  }

  if (pendingSellerActionCount > 0) {
    isPendingOffersBgColor = true;
    isCtaButton = true;
    ctaText = t('NEGOTIATION_LISTING.OFFERS_SHARED.CTA.RESPOND');
  }

  return { offersText, isActiveOffersTextColor, isPendingOffersBgColor, shouldCtaLaunchModal, ctaText, isCtaButton };
};
